// extracted by mini-css-extract-plugin
export default {"Wrapper":"Settings_Wrapper__QoJf3","Nav":"Settings_Nav__8YfEH","deactiveNav":"Settings_deactiveNav__OcQ2d","activeNav":"Settings_activeNav__w+Q2F"};